import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from './AuthContext';
import App from './App';
import { postLogin } from './apiService';
import { jwtDecode } from 'jwt-decode';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Person4Icon from '@mui/icons-material/Person4';
import PersonIcon from "@mui/icons-material/Person";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import Logo from '../src/components/pages/Logo/favicon.png';

const LoginForm = () => {
    const history = useHistory();
    const { isAuthenticated, login } = useAuth();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loginFailed, setLoginFailed] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    // const [companyId, setCompanyId] = useState('');
    //const [branchId, setBranchId] = useState('');
    const location = useLocation();

    const branchId = 1;
    const companyId = 1;

    useEffect(() => {
        setIsAnimating(true);
    }, []);

    const handleLogin = async () => {
        try {

            const jwtToken = await performLogin();
            const responseData = jwtDecode(jwtToken);
            const keysToRemove = ['iss', 'exp', 'ttp', 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name', 'aud'];
            const permissions = Object.keys(responseData).filter(
                (key) => key !== 'companyId' && key !== 'userId' && !keysToRemove.includes(key)
            );

            let isSuper = false;
            if (responseData.isSuperAdmin.toLowerCase() === "true") {
                isSuper = true;
            }

            if (isSuper == false) {
                const parsedCompanyId = parseInt(responseData.companyId, 10);

                if (parsedCompanyId === companyId) {
                    login(responseData.companyId, responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, responseData.CompanyName, permissions, jwtToken, responseData.roleName, responseData.branchstate, responseData.username);
                    const redirectParam = new URLSearchParams(location.search).get("redirect");
                    const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
                    history.replace(redirectPath);
                }
                else {
                    toast.error('Invalid User !', {
                        position: "top-center",
                    });
                }
            }
            else {
                login(responseData.companyId, responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, responseData.CompanyName, permissions, jwtToken, responseData.roleName, responseData.branchstate, responseData.username);
                const redirectParam = new URLSearchParams(location.search).get("redirect");
                const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
                history.replace(redirectPath);
            }


        } catch (error) {
            toast.error('Login failed', {
                position: "top-center",
            });
        }
    };

    const performLogin = async () => {
        const loginData = {
            UserName: username,
            Password: password,
            CompanyId: companyId,
            BranchId: branchId
        };

        const response = await postLogin('LoginApi', loginData);

        if (response.responseCode === '1111') {
            const jwtToken = response.response_data.token;

            return jwtToken;
        } else {
            throw new Error(response.Message);
        }
    };

    if (isAuthenticated) {
        return <App />;
    }

    //     return (
    //         <div
    //             style={{
    //                 display: "flex",
    //                 justifyContent: "center",
    //                 alignItems: "center",
    //                 minHeight: "100vh",
    //                 background: "#fff",
    //                 color: "#fff",
    //                 fontFamily: "Arial, sans-serif",
    //             }}
    //         >
    //             <div
    //                 style={{
    //                     width: "100%",
    //                     maxWidth: "400px",
    //                     padding: "30px",
    //                     borderRadius: "12px",
    //                     background: "rgba(105, 36, 79, 1)",
    //                     boxShadow: "0 8px 24px rgba(0, 0, 0, 0.5)",
    //                     textAlign: "center",
    //                 }}
    //             >
    //                 <div
    //                     style={{
    //                         display: "flex",
    //                         alignItems: "center",
    //                         justifyContent: "center",
    //                         gap: "20px",
    //                     }}
    //                 >
    //                     <img
    //                         src={Logo}
    //                         alt="Logo"
    //                         style={{
    //                             width: "35px",
    //                             height: "35px",
    //                             borderRadius: "50%",
    //                             boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
    //                             marginTop: "-10px",
    //                             marginLeft: '-20px',
    //                             background: 'whitesmoke',
    //                             borderRadius: '20px'

    //                         }}
    //                     />
    //                     <h5
    //                         style={{
    //                             fontWeight: "600",
    //                             fontFamily: "cursive",
    //                             color: "whitesmoke",
    //                         }}
    //                     >
    //                         Faman
    //                     </h5>
    //                 </div>
    //                 <p style={{ marginBottom: "30px", color: "whitesmoke", fontFamily: 'monospace' }}>
    //                     Login To Your Account
    //                 </p>

    //                 <form
    //                     onSubmit={(e) => {
    //                         e.preventDefault();
    //                         handleLogin();
    //                     }}
    //                 >
    //                     {/* Username field with icon */}
    //                     <div style={{ position: "relative", marginBottom: "15px" }}>
    //                         <FaUser
    //                             style={{
    //                                 position: "absolute",
    //                                 top: "50%",
    //                                 left: "10px",
    //                                 transform: "translateY(-50%)",
    //                                 color: "darkslateblue",
    //                             }}
    //                         />
    //                         <input
    //                             type="text"
    //                             placeholder="User Name"
    //                             value={username}
    //                             onChange={(e) => setUsername(e.target.value)}
    //                             style={{
    //                                 width: "100%",
    //                                 padding: "10px 10px 10px 40px",
    //                                 borderRadius: "8px",
    //                                 border: "1px solid #4c6793",
    //                                 color: "black",
    //                                 outline: "none",
    //                             }}
    //                         />
    //                     </div>

    //                     {/* Password field with icon and visibility toggle */}
    //                     <div style={{ position: "relative", marginBottom: "15px" }}>
    //                         <FaLock
    //                             style={{
    //                                 position: "absolute",
    //                                 top: "50%",
    //                                 left: "10px",
    //                                 transform: "translateY(-50%)",
    //                                 color: "darkslateblue",
    //                             }}
    //                         />
    //                         <input
    //                             type={showPassword ? "text" : "password"}
    //                             placeholder="Password"
    //                             value={password}
    //                             onChange={(e) => setPassword(e.target.value)}
    //                             style={{
    //                                 width: "100%",
    //                                 padding: "10px 10px 10px 40px",
    //                                 borderRadius: "8px",
    //                                 border: "1px solid #4c6793",
    //                                 color: "black",
    //                                 outline: "none",
    //                             }}
    //                         />
    //                         <div
    //                             onClick={() => setShowPassword((prev) => !prev)}
    //                             style={{
    //                                 position: "absolute",
    //                                 top: "50%",
    //                                 right: "10px",
    //                                 transform: "translateY(-50%)",
    //                                 color: "#ccc",
    //                                 cursor: "pointer",
    //                             }}
    //                         >
    //                             {showPassword ? <FaEyeSlash style={{ color: 'red' }} /> : <FaEye style={{ color: 'darkmagenta' }} />}
    //                         </div>
    //                     </div>

    //                     <button
    //                         type="submit"
    //                         style={{
    //                             width: "100%",
    //                             padding: "10px",
    //                             marginTop: "15px",
    //                             borderRadius: "8px",
    //                             border: "1px solid #fff",
    //                             background: "transparent",
    //                             color: "#fff",
    //                             fontWeight: "bold",
    //                             cursor: "pointer",
    //                             transition: "all 0.3s ease",
    //                         }}
    //                         onMouseEnter={(e) => {
    //                             e.target.style.background = "#fff";
    //                             e.target.style.color = "#000";
    //                         }}
    //                         onMouseLeave={(e) => {
    //                             e.target.style.background = "transparent";
    //                             e.target.style.color = "#fff";
    //                         }}
    //                     >
    //                         Login
    //                     </button>
    //                 </form>

    //                 {/* <button
    //                     style={{
    //                         width: "100%",
    //                         padding: "10px",
    //                         marginTop: "15px",
    //                         borderRadius: "8px",
    //                         border: "1px solid #fff",
    //                         background: "transparent",
    //                         color: "#fff",
    //                         fontWeight: "bold",
    //                         cursor: "pointer",
    //                     }}
    //                 >
    //                     Property Binnits
    //                 </button> */}
    //             </div>
    //         </div >
    //     );
    // };

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                background: "#0d0d0d", // Dark background
                color: "#e0e0e0",
                fontFamily: "Arial, sans-serif",
            }}
        >
            <div
                style={{
                    width: "100%",
                    maxWidth: "400px",
                    padding: "30px",
                    borderRadius: "12px",
                    background: "linear-gradient(145deg, #1a1a1a, #2c2c2c)", // Smooth gradient
                    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.7)",
                    textAlign: "center",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "20px",
                    }}
                >
                    <img
                        src={Logo}
                        alt="Logo"
                        style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            boxShadow: "0 4px 10px rgba(255, 255, 255, 0.1)",
                            marginTop: "-10px",
                            marginLeft: "-20px",
                            background: "#fff",
                        }}
                    />
                    <h5
                        style={{
                            fontWeight: "600",
                            fontFamily: "cursive",
                            color: "#ff66cc", // Vibrant magenta accent
                        }}
                    >
                        Faman
                    </h5>
                </div>

                <p
                    style={{
                        marginBottom: "30px",
                        color: "#bbb",
                        fontFamily: "monospace",
                    }}
                >
                    Login To Your Account
                </p>

                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleLogin();
                    }}
                >
                    {/* Username field */}
                    <div style={{ position: "relative", marginBottom: "15px" }}>
                        <FaUser
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "10px",
                                transform: "translateY(-50%)",
                                color: "#ff66cc",
                            }}
                        />
                        <input
                            type="text"
                            placeholder="User Name"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            style={{
                                width: "100%",
                                padding: "10px 10px 10px 40px",
                                borderRadius: "8px",
                                border: "1px solid #444",
                                background: "#1e1e1e",
                                color: "#e0e0e0",
                                outline: "none",
                                transition: "0.3s",
                            }}
                            onFocus={(e) => (e.target.style.border = "1px solid #ff66cc")}
                            onBlur={(e) => (e.target.style.border = "1px solid #444")}
                        />
                    </div>

                    {/* Password field */}
                    <div style={{ position: "relative", marginBottom: "15px" }}>
                        <FaLock
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "10px",
                                transform: "translateY(-50%)",
                                color: "#ff66cc",
                            }}
                        />
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            style={{
                                width: "100%",
                                padding: "10px 10px 10px 40px",
                                borderRadius: "8px",
                                border: "1px solid #444",
                                background: "#1e1e1e",
                                color: "#e0e0e0",
                                outline: "none",
                                transition: "0.3s",
                            }}
                            onFocus={(e) => (e.target.style.border = "1px solid #ff66cc")}
                            onBlur={(e) => (e.target.style.border = "1px solid #444")}
                        />
                        <div
                            onClick={() => setShowPassword((prev) => !prev)}
                            style={{
                                position: "absolute",
                                top: "50%",
                                right: "10px",
                                transform: "translateY(-50%)",
                                color: "#ccc",
                                cursor: "pointer",
                            }}
                        >
                            {showPassword ? (
                                <FaEyeSlash style={{ color: "#ff4d4d" }} />
                            ) : (
                                <FaEye style={{ color: "#ff66cc" }} />
                            )}
                        </div>
                    </div>

                    <button
                        type="submit"
                        style={{
                            width: "100%",
                            padding: "10px",
                            marginTop: "15px",
                            borderRadius: "8px",
                            border: "1px solid #ff66cc",
                            background: "transparent",
                            color: "#ff66cc",
                            fontWeight: "bold",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.background = "#ff66cc";
                            e.target.style.color = "#000";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = "transparent";
                            e.target.style.color = "#ff66cc";
                        }}
                    >
                        Login
                    </button>
                </form>
            </div>
        </div>
    );

}
export default LoginForm;
